import React from "react";
import { AiOutlineEye } from "react-icons/ai";
import BannerImageUpload from "./BannerImageUpload";
import { HexColorPicker } from "react-colorful";
import { Link } from "react-router-dom";
import { ROUTE_BASE_URL } from "../../../api/common";
import "../../../assets/css/custom.css";

const abstractBackgroundImages = [
  "https://placehold.co/100x200",
  "https://placehold.co/300x400",
  "https://placehold.co/100x400",
  "https://placehold.co/700x400",
];

const GradientColorPicker = ({
  gradient,
  startColor,
  endColor,
  handleStartColorChange,
  handleEndColorChange,
}) => {
  return (
    <div>
      <div
        className="gradient-preview"
        style={{
          background: gradient || `linear-gradient(90deg, ${startColor}, ${endColor})`,
          height: "50px",
          borderRadius: "5px",
        }}
      ></div>
      <div className="gradiet_preview_clr">
        <div>
          <p>Start Color</p>
          <HexColorPicker color={startColor} onChange={handleStartColorChange} />
        </div>
        <div>
          <p>End Color</p>
          <HexColorPicker color={endColor} onChange={handleEndColorChange} />
        </div>
      </div>
    </div>
  );
};

const RegistrationPage = ({
  eventData,
  eventPageData,
  isEventLogEnabled,
  gradient,
  backgroundOption,
  selectedColor,
  primaryColor,
  selectedBackgroundImage,
  selectedBackgroundImages,
  isPrimaryColorPickerOpen,
  fileError,
  startColor,
  endColor,
  formState,
  handleEventLogToggle,
  handleBackgroundOptionChange,
  handleColorChange,
  handlePrimaryColorChange,
  handleFormChange,
  handleFileUpload,
  handleImageClick,
  handleImageUpload,
  handleFileChange,
  handleStartColorChange,
  handleEndColorChange,
  setIsPrimaryColorPickerOpen,
  setFileError,
  setBannerImageError,
  bannerImageError,
}) => {
  const formatTime = (date) => {
    if (!date) return "";
    const formattedDate = new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).replace(/ /g, ' ');
    return formattedDate.replace(/ ([A-Za-z]+) /, ' $1, ');
  };

  // Parse eventPageData with defaults
  let parsedEventTitle = { show: "no", value: "" };
  let parsedEventLogo = { show: "no", value: "" };
  let parsedEventDate = { show: "no", value: "" };
  let parsedEventBanner = { show: "no", value: "" };
  let parsedCustomTheme = { show: "no", type: "abstract", abstract: "", gradient: "", color: "#ffffff", primary_color: "#007bff", image_url: "" };
  let parsedDisplayEventPolicies = { show: "no" };
  let parsedRegistrationTitle = { show: "no", value: "" };

  if (eventPageData) {
    try {
      parsedEventTitle = JSON.parse(eventPageData.event_title || '{"show":"no","value":""}');
      parsedEventLogo = JSON.parse(eventPageData.event_organizer_logo || '{"show":"no","value":""}');
      parsedEventDate = JSON.parse(eventPageData.event_date || '{"show":"no","value":""}');
      parsedEventBanner = JSON.parse(eventPageData.event_banner_image || '{"show":"no","value":""}');
      parsedCustomTheme = JSON.parse(eventPageData.custom_theme || '{"show":"no","type":"abstract","abstract":"","gradient":"","color":"#ffffff","primary_color":"#007bff","image_url":""}');
      parsedDisplayEventPolicies = JSON.parse(eventPageData.display_event_policies || '{"show":"no"}');
      parsedRegistrationTitle = JSON.parse(eventPageData.registration_title || '{"show":"no","value":""}');
    } catch (error) {
      console.error("Error parsing eventPageData:", error);
    }
  }

  return (
    <div className="row clearfix">
      <div className="col-lg-12">
        <div className="card registration-card">
          {/* <div className="card-header setting_card_heading">
            <div className="row align-items-center">
              <div className="col-lg-9 p-0">
                <h5>Registration Page</h5>
              </div>
              <div className="col-lg-3 text-right preview_div">
                <h5>
                  Preview <span><AiOutlineEye size={20} /></span>
                </h5>
              </div>
            </div>
          </div> */}

          <div className="card-body border-0">
            {/* Event Title */}
            <div className="row align-items-center row-custom">
              <div className="col-lg-5">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="lv-btn small-switch"
                      checked={formState.eventTitle}
                      onChange={(e) => handleFormChange("eventTitle", e.target.checked)}
                    />
                    <span className="slider round"></span>
                  </label>
                  <span className="ml-2 text-caps">Event Title</span>
                </div>
              </div>
              <div className="col-lg-7">
                <p className="mb-0">
                  {formState.eventTitleValue || eventData?.event_name || parsedEventTitle.value || "Event Title"}
                </p>
              </div>
            </div>

            {/* Event Logo */}
            <div className="row align-items-center row-custom">
              <div className="col-lg-5">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="lv-btn small-switch"
                      checked={formState.eventLogo}
                      onChange={(e) => handleFormChange("eventLogo", e.target.checked)}
                    />
                    <span className="slider round"></span>
                  </label>
                  <span className="ml-2 text-caps">Event Logo</span>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="logo_size_register">
                  {formState.eventLogo && (eventData?.event_logo || parsedEventLogo.value) ? (
                    <img
                      src={eventData?.event_logo || parsedEventLogo.value || "../assets/images/dummylogo.png"}
                      alt="Event Logo"
                      className="img-thumbnail"
                      style={{  }}
                    />
                  ) : (
                    <p className="mb-0">
                      To add logo{" "}
                      <Link to={`${ROUTE_BASE_URL}/event-registration-info`} className="click-link"><b>click here</b></Link>
                    </p>
                  )}
                </div></div>
            </div>

            {/* Event Date, Time & Location */}
            <div className="row align-items-center row-custom">
              <div className="col-lg-5">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="lv-btn small-switch"
                      checked={formState.eventDateTimeLocation}
                      onChange={(e) => handleFormChange("eventDateTimeLocation", e.target.checked)}
                    />
                    <span className="slider round"></span>
                  </label>
                  <span className="ml-2 text-caps">Event Date, Time & Location</span>
                </div>
              </div>
              <div className="col-lg-7">
                <p className="mb-0">
                  {parsedEventDate?.value && formatTime(parsedEventDate.value)}
                  {eventData?.venue_city && ` | ${eventData.venue_city}`}
                </p>
              </div>
            </div>

            {/* Registration Title */}
            <div className="row align-items-center row-custom">
              <div className="col-lg-5">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="lv-btn small-switch"
                      checked={formState.registrationTitle.show}
                      onChange={(e) =>
                        handleFormChange("registrationTitle", {
                          ...formState.registrationTitle,
                          show: e.target.checked,
                        })
                      }
                    />
                    <span className="slider round"></span>
                  </label>
                  <span className="ml-2 text-caps">Registration Title</span>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="form-group pos_relative">
                  <input
                    type="text"
                    className="form-control form-control-custom"
                    placeholder="Enter Registration Title"
                    value={formState.registrationTitle.value}
                    onChange={(e) =>
                      handleFormChange("registrationTitle", {
                        ...formState.registrationTitle,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            {/* Event Banner */}
            <div className="row align-items-center row-custom">
              <div className="col-lg-5">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="lv-btn small-switch"
                      checked={formState.eventBanner.show}
                      onChange={(e) =>
                        handleFormChange("eventBanner", {
                          ...formState.eventBanner,
                          show: e.target.checked,
                        })
                      }
                    />
                    <span className="slider round"></span>
                  </label>
                  <span className="ml-2 text-caps">Event Banner</span>
                </div>

              </div>
              <div className="col-lg-7">
                <BannerImageUpload
                  onFileUpload={handleFileUpload}
                  setFileError={setBannerImageError}
                />
                {/* {fileError && <div className="invalid-feedback">{fileError}</div>} */}
                <div className="w-100 mt-2">
                  <p>
                    Image should be jpg or png format
                    Recommended Dimension: 800 x 270 pixels
                  </p>
                </div>
                {bannerImageError && (
                  <p className="text-danger mt-1">{bannerImageError}</p>
                )}
                {formState.eventBanner.value && (
                  <img
                    src={formState.eventBanner.value}
                    alt="Event Banner"
                    className="img-thumbnail mt-2"
                    style={{ width: "100px", height: "100px" }}
                  />
                )}
              </div>
            </div>

            {/* Display Event Policies */}
            <div className="row align-items-center row-custom">
              <div className="col-lg-5">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="lv-btn small-switch"
                      checked={formState.displayEventPolicies}
                      onChange={(e) => handleFormChange("displayEventPolicies", e.target.checked)}
                    />
                    <span className="slider round"></span>
                  </label>
                  <span className="ml-2 text-caps">Display Event Policies</span>
                </div>
              </div>
              <div className="col-lg-7">
                <p className="text-secondary" style={{ margin: 0 }}>
                  If enabled, event policies will be displayed on the registration page.
                </p>
              </div>
            </div>

            {/* Custom Theme */}
            <div className="row row-custom">
              <div className="col-lg-5">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="lv-btn small-switch"
                      checked={formState.customTheme}
                      onChange={(e) => handleFormChange("customTheme", e.target.checked)}
                    />
                    <span className="slider round"></span>
                  </label>
                  <span className="ml-2 text-caps">Custom Theme</span>
                </div>
              </div>
              <div className="col-lg-7">
                <p className="text-secondary">
                  Customize the background behind the registration form
                </p>

                {/* Background Options */}
                <div className="background-options mb-2">
                  {["abstract", "color", "gradient", "image"].map((option) => (
                    <label key={option} className="mr-3">
                      <input
                        type="radio"
                        name="backgroundOption"
                        value={option}
                        checked={backgroundOption === option}
                        onChange={() => handleBackgroundOptionChange(option)}
                      />
                      {option.charAt(0).toUpperCase() + option.slice(1)}
                    </label>
                  ))}
                </div>

                {/* Gradient Picker */}
                {backgroundOption === "gradient" && (
                  <GradientColorPicker
                    gradient={gradient}
                    startColor={startColor}
                    endColor={endColor}
                    handleStartColorChange={handleStartColorChange}
                    handleEndColorChange={handleEndColorChange}
                  />
                )}

                {/* Color Picker */}
                {backgroundOption === "color" && (
                  <div className="mb-2">
                    <HexColorPicker color={formState.customThemeColor} onChange={handleColorChange} />
                    <div className="form-group pos_relative d-flex align-items-center mt-2">
                      <input
                        type="text"
                        value={formState.customThemeColor}
                        onChange={(e) => handleColorChange(e.target.value)}
                        className="form-control form-control-custom text-center"
                      />
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          backgroundColor: formState.customThemeColor,
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          marginLeft: "0.5rem",
                        }}
                      ></div>
                    </div>
                  </div>
                )}

                {/* Abstract Picker */}
                {backgroundOption === "abstract" && (
                  <div className="abstract-image-picker">
                    <div className="image-options d-flex flex-wrap">
                      {abstractBackgroundImages.map((image, index) => (
                        <div
                          key={index}
                          className={`image-option ${selectedBackgroundImages.includes(image) ? "selected" : ""
                            }`}
                          onClick={() => handleImageClick(image)}
                          style={{
                            backgroundImage: `url(${image})`,
                            border: selectedBackgroundImages.includes(image)
                              ? "5px solid #007bff"
                              : "none",
                          }}
                        />
                      ))}
                    </div>
                  </div>
                )}

                {/* Image Upload */}
                {backgroundOption === "image" && (
                  <div className="form-group">
                    <label>
                      Upload Image <span className="text-danger">*</span>
                    </label>
                    <div className="pos_re">
                      <img
                        src={selectedBackgroundImage || parsedCustomTheme.image_url || "https://placehold.co/700x400"}
                        width="100"
                        height="100"
                        className="img-thumbnail width_profile_image"
                        alt="Uploaded"
                        onClick={handleImageUpload}
                        style={{ cursor: "pointer", objectFit: "cover" }}
                      />
                      <i
                        onClick={handleImageUpload}
                        className="fa fa-pencil upload_image_edit_icon"
                        style={{ cursor: "pointer" }}
                      />
                      <input
                        type="file"
                        id="imageUploadInput"
                        style={{ display: "none" }}
                        accept="image/*"
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>
                )}

                {/* Primary Color */}
                <div className="mt-3">
                  <label className="text-primary"><b>Primary Color</b></label>
                  <p className="text-secondary">
                    This will be the color for buttons, links, and highlighted elements
                  </p>
                  <div className="d-flex align-items-center">
                    <input
                      type="text"
                      value={primaryColor}
                      readOnly
                      onClick={() => setIsPrimaryColorPickerOpen(!isPrimaryColorPickerOpen)}
                      className="form-control form-control-custom text-center"
                      style={{ cursor: "pointer" }}
                    />
                    <div
                      style={{
                        width: "30px",
                        height: "30px",
                        backgroundColor: primaryColor,
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        marginLeft: "0.5rem",
                      }}
                    ></div>
                  </div>
                  {isPrimaryColorPickerOpen && (
                    <div className="mt-2">
                      <HexColorPicker color={primaryColor} onChange={handlePrimaryColorChange} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;